import { render, staticRenderFns, recyclableRender, components } from "./u-empty.vue?vue&type=template&id=0d5b1156&scoped=true&"
var renderjs
import script from "./u-empty.vue?vue&type=script&lang=js&"
export * from "./u-empty.vue?vue&type=script&lang=js&"
import style0 from "./u-empty.vue?vue&type=style&index=0&id=0d5b1156&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../Ruanjian/HBuilderX/plugins/uniapp-cli/node_modules/@dcloudio/vue-cli-plugin-uni/packages/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d5b1156",
  null,
  false,
  components,
  renderjs
)

component.options.__file = "uni_modules/uview-ui/components/u-empty/u-empty.vue"
export default component.exports